import { VraagboomTextResultaat } from '@models/vragenboom';
import { ValidatieregelHelper } from '@services/public_api';
import { Antwoord, ValidatieParameter } from '@models/claims';

// @dynamic
export class RegexValidator {
  static isValidRegexAnswer(antwoord: Antwoord, value: string): boolean {
    if (antwoord == null) {
      return false;
    }

    if (value) {
      const regex: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'REGEX');
      if (regex) {
        const regexValidator: RegExp = new RegExp(regex['validatie_parameters']);
        if (!regexValidator.test(value)) {
          return false;
        }
      }
    }
    return true;
  }

  static isValidRegex(antwoorden: Antwoord[], resultaat: VraagboomTextResultaat) {
    if (antwoorden == null)
      return false;

    if (resultaat?.value == null)
      return true;

    for (const antwoord of antwoorden) {
      if (!this.isValidRegexAnswer(antwoord, resultaat.value))
        return false;
    }

    return true;
  }
}
